import queryString from 'utils/queryString';

import nextApiGetRequest from '../lib/nextApiGetRequest';
import { requestServerContent } from '../lib/serverContent';

const request = async (params = {}) => {
  // On the server the content store lives in the same process — read it
  // directly instead of HTTP-looping through our own /api/content route.
  if (typeof window === 'undefined') {
    const direct = await requestServerContent(params);
    if (direct) return direct.data;
  }

  const query = queryString.stringify(params, {
    arrayFormatSeparator: ',',
  });

  const response = await nextApiGetRequest(`/api/content?${query}`);
  const json = await response.json();

  return json.data;
};

const content = {
  product: async productId => request({ type: 'product', id: productId }),
  products: async productIds => request({ type: 'products', ids: productIds }),
  category: async categoryId => request({ type: 'category', id: categoryId }),
  categories: async categoryIds => request({ type: 'categories', ids: categoryIds }),
  banner: async () => request({ type: 'banner' }),
  carousel: async () => request({ type: 'carousel' }),
  // Blog is a non-critical homepage section sourced from Ghost's RSS feed.
  // If the fetch fails (network, 5xx, malformed JSON), fall back to an empty
  // list so the consumer can hide the section instead of crashing the page.
  blog: async () => {
    try {
      const data = await request({ type: 'blog' });
      return Array.isArray(data) ? data : [];
    } catch (e) {
      console.error('contentApi.blog failed', e);
      return [];
    }
  },
  singleType: async type => request({ type: 'singleType', id: type }),
};

export default content;
